import script from "./module1.vue?vue&type=script&lang=ts&setup=true"
export * from "./module1.vue?vue&type=script&lang=ts&setup=true"

import "./module1.vue?vue&type=style&index=0&id=3d287e15&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d287e15"]])

export default __exports__